/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ManualLegalVerificationSource = {
    Partner: 'PARTNER',
    OfficialRegistry: 'OFFICIAL_REGISTRY',
    RegistrationProof: 'REGISTRATION_PROOF'
} as const;
export type ManualLegalVerificationSource = typeof ManualLegalVerificationSource[keyof typeof ManualLegalVerificationSource];


export function instanceOfManualLegalVerificationSource(value: any): boolean {
    for (const key in ManualLegalVerificationSource) {
        if (Object.prototype.hasOwnProperty.call(ManualLegalVerificationSource, key)) {
            // @ts-ignore
            if (ManualLegalVerificationSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ManualLegalVerificationSourceFromJSON(json: any): ManualLegalVerificationSource {
    return ManualLegalVerificationSourceFromJSONTyped(json, false);
}

export function ManualLegalVerificationSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualLegalVerificationSource {
    return json as ManualLegalVerificationSource;
}

export function ManualLegalVerificationSourceToJSON(value?: ManualLegalVerificationSource | null): any {
    return value as any;
}

